<template>
    <div class="xtxx">
<!-- 维修处理页 -->
       
<div class="content">
    <van-tabs v-model="active" color="#00d2ff">
  <van-tab title="待签收">

           <div class="search">
            <van-search
                v-model="search"
                shape="round"
                placeholder="请输入搜索关键词"
                 @search="onSearch"
            />
        </div>


            <van-pull-refresh v-model="refreshing1" @refresh="onRefresh1" >
                <van-list
                    v-model="loading1"
                    :finished="finished1"
                    finished-text="没有更多了"
                    @load="onLoad1"
                >
                    <div class="pj" v-for="(item,index) in list1" :key="index" @click="goxq(item.id)">
                        <!-- <img src="../../assets/tsbx/ls.png" alt=""> -->
                        <div class="xq">
                            <span> <span class="blue">[{{item.repairType}}]</span>{{item.houseOwnerName}}</span>
                            <span>日期:{{item.createdDate}} </span>
                            <span>地址:{{ item.address.split(' ')[0] }}栋{{ item.address.split(' ')[1] }}单元{{ item.address.split(' ')[2] }}室 </span>
                            <!-- <button class="dpj">{{item.status}}</button> -->
                            <!-- <button class="dpj orange">未评价</button> -->
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>


            

  </van-tab>
  <van-tab title="待处理">
           <div class="search">
            <van-search
                v-model="search"
                shape="round"
                placeholder="请输入搜索关键词"
                 @search="onSearch"
            />
        </div>

           <van-pull-refresh v-model="refreshing2" @refresh="onRefresh2" >
                <van-list
                    v-model="loading2"
                    :finished="finished2"
                    finished-text="没有更多了"
                    @load="onLoad2"
                >
                    <div class="pj" v-for="(item,index) in list2" :key="index" @click="goxq(item.id,'zz')">
                        <!-- <img src="../../assets/tsbx/ls.png" alt=""> -->
                        <div class="xq">
                            <span> <span class="blue">[{{item.repairType}}]</span>{{item.houseOwnerName}}</span>
                            <span>日期:{{item.createdDate}} </span>
                            <span>地址:{{ item.address.split(' ')[0] }}栋{{ item.address.split(' ')[1] }}单元{{ item.address.split(' ')[2] }}室 </span>
                            <!-- <button class="dpj">{{item.status}}</button> -->
                            <!-- <button class="dpj orange">未评价</button> -->
                        </div>
                    </div>
                </van-list>
            </van-pull-refresh>




  </van-tab>
</van-tabs>
</div>


       
    </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
    data() {
        return {
            active:0,
            tp:'',
            search:'',
            active:'',
            list1:[],
            list2:[],
            loading1: false,
			loading2: false,
            finished1: false,
			finished2: false,
            refreshing1: false,
			refreshing2: false,
            currpage1:0,//待签收页码
            currpage2:0,//待办结页码
        }
    },
    computed: {
 	...mapState(['userInfo','identity','houseId','isactive']),
 },
    mounted() {
        this.tp = this.$route.query.tp
        this.onLoad1()
        // this.reload()

    },
    methods: {

        onSearch(val) {
                                  (this.list1 = []),
        (this.loading1 = false),
        (this.finished1 = false),
        (this.refreshing1 = false),
        (this.currpage1 = 0);
this.getdata(this.$route.query.tp)
            
			},
        goxq(id,type){
            if(!type){

                this.$router.push({ path: "/tsbx/wxxq", query: {id:id,type:3} });//进入报修-报修详情页（派工等
            }else{
                
                this.$router.push({ path: "/tsbx/wxxq", query: {id:id,type:4} });//进入报修-报修详情页（中断
            }

            
        },
        getdata(name){

            if(this.active == '0'){
                
                let data = new FormData();
                 var jsonData = {};
                     jsonData = {
                        status:11,
                         pageNum:this.currpage1,
                         pageSize:15,
                         complaintTitle:this.search
                 }
                       for (let key in jsonData) {
         data.append(key, jsonData[key]);
       }
                this.$axios.post('/api/v1/repair/sysList/wxcl', data).then(res => {
          if (this.currpage1 == 0) {
            this.list1 = res.data;

          } else {
            if (res.data) {
              this.list1 = this.list1.concat(res.data);
            }
          }

          this.loading1 = false;
          this.refreshing1 = false;

          if (!res.data|| res.data.length < 10) {
            this.finished1 = true;
          } else {
            this.currpage1++;
            this.finished1 = false;
          }
                });
            }else if(this.active == '1'){

                                let data = new FormData();
                 var jsonData = {};
                     jsonData = {
                        status:21,
                         pageNum:this.currpage2,
                         pageSize:15,
                         complaintTitle:this.search
                 }
                       for (let key in jsonData) {
         data.append(key, jsonData[key]);
       }


                this.$axios.post('/api/v1/repair/sysList/wxcl', data).then(res => {
          if (this.currpage2 == 0) {
            this.list2 = res.data;

          } else {
            if (res.data) {
              this.list2 = this.list2.concat(res.data);
            }
          }

          this.loading2 = false;
          this.refreshing2 = false;

          if (!res.data|| res.data.length < 10) {
            this.finished2 = true;
          } else {
            this.currpage2++;
            this.finished2 = false;
          }
                });
            }
            
        },
        onLoad1(){
           if (this.refreshing1) {
				// 清空列表数据
				this.currpage1 = 0;
				this.list1 = [];
				this.refreshing1 = false;
           }
           this.getdata(this.$route.query.tp)
		   
        },
        onRefresh1() {
			  this.finished1 = false;
			  // 重新加载数据
			  // 将 loading 设置为 true，表示处于加载状态
			  this.loading1 = true;
			  this.onLoad1();
        },
		onLoad2(){
		   if (this.refreshing2) {
				// 清空列表数据
				this.currpage2 = 0;
				this.list2 = [];
				this.refreshing2 = false;
		   }
		   this.getdata(this.$route.query.tp)
		},
		onRefresh2() {
			  this.finished2 = false;
			  // 重新加载数据
			  // 将 loading 设置为 true，表示处于加载状态
			  this.loading2 = true;
			  this.onLoad2();
		},
        
    },
}
</script>
<style lang="less" scoped="scoped">
	.orange{
		color: rgb(240, 182, 49);
	}
    	.blue{
		color: #28aff6;
	}
    .content{
          height: 100%;
  width: 92%;
  margin: 0 4% 0 4%;
    }
    .xtxx{
        height: calc(100% - 50px);
        width: 100%;
        display: flex;
        background-color: #fff;
        flex-direction: column;
        align-items: center;
        .van-tabs{
            height: 100%;
        }
        .van-pull-refresh{
            height: 100%;
        }
        .van-tab__pane{
            height: 100%;
        }
        .van-tabs__content{
            height: calc(100vh - 140px);
        }
        .van-pull-refresh__track{
            overflow: hidden;
            overflow-y: scroll;
        }
        .wdxx{
            margin: 26px 10px 26px 10px;
        }
        .biaoqian{
            height: 100%;
            width: 100%;
        }
        .xtxxc{
            width: calc(100% - 6%);
            height: 100%;
        }
        .pj{
            display: flex;
            width: 94%;
            // height: 100px;
			padding:14px 10px ;
            border-radius: 10px;
            display: flex;
            align-items: center;
            box-shadow: 0px 0px 5px #e6e6e6;
            margin-top: 10px;
            img{
                margin-left: 2%;
                height: 80px;
                width: 80px;
            }
            .xq{
                height: 100%;
                width: 100%;
                margin-left: 2%;
                display: flex;
                flex-direction: column;
                position: relative;
                span{
                    width:100%;
                }
                span:nth-child(1){
                    font-weight: bold;
                }
                span:nth-child(2){
                    margin-top: 5px;
                    color: #999999;
                }
                span:nth-child(3){
                    margin-top: 5px;
                    color: #999999;
                }
                // .dpj{
                //     height: 25px;
                //     top: calc(50% - 15px);
                //     position: absolute;
                //     right: 2%;
                //     border: 1px solid #00d2ff;
                //     color: #00d2ff;
                //     background-color: transparent;
                //     border-radius: 30px;
                //     font-size: 15px;
                // }
                .dpj{
                    height: 25px;
                    top: calc(50% - 15px);
                    position: absolute;
                    right: 2%;
                    border: 1px solid rgb(240, 182, 49);
                    color: rgb(240, 182, 49);
                    background-color: transparent;
                    border-radius: 30px;
                    font-size: 15px;
                }
            }
        }
        .search{
            width: 100%;
            height: 50px;
            display:block;
        }
        .van-tabs__line{
            background-color: #28aff6;
            width: 90px;
            border-radius: 5px;
        }
        .van-list{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .wdxxitem{
            color: white;
            margin-top: 20px;
            font-weight: 600;
            height: 70px;
            width:90%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #b7b7b7;
            border-radius: 10px;
        }
        ::-webkit-scrollbar{
            display: none;
        }
    }
</style>